import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { INDUSTRIES } from "@/data/content";

const IndustriesSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-white" id="industries" data-testid="industries-section">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline="Industries We Serve"
          title="Certification Across Every Vehicle Category"
          description="From electric mobility to heavy commercial platforms, we cover the full spectrum of Indian vehicle categories."
          className="mb-14"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-5">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} variants={fadeUp} custom={i % 5}>
              <div
                data-testid={`industry-card-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group h-full rounded-2xl border border-slate-200 bg-white p-6 text-center hover:border-[#1E40AF]/40 hover:shadow-lg hover:shadow-slate-900/5 hover:-translate-y-1 transition-[transform,box-shadow,border-color] duration-300"
              >
                <span className="mx-auto inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-slate-100 text-slate-700 group-hover:bg-[#1E40AF] group-hover:text-white transition-colors">
                  <ind.icon className="w-6 h-6" strokeWidth={1.5} />
                </span>
                <h3 className="mt-4 font-display font-semibold text-[#0F172A] text-sm sm:text-[15px] leading-snug">{ind.name}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
